import { LocationChart } from "./Charts";

const LocationBased = () => {
  return (
    <div className="col-span-12 card">
      <div className="card-body">
        <div className="flex items-center gap-2">
          <h6 className="mb-3 text-15 grow">Pedidos nos útimos 12 meses</h6>
        </div>
        <LocationChart chartId="responseTimes" data-chart-colors='["bg-red-500"]' />
      </div>
    </div>
  );
};

export default LocationBased;
